import { Injectable } from '@angular/core';
import { HisBackendService } from 'hisng';
import { Observable } from 'rxjs';
import { ResearchPartner, ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';

@Injectable()
export class ResearchPartnerService {

    constructor( private backendService: HisBackendService ) { }

    /**
     * get research partner by id from database
     *
     * @param id of research partner
     */
    getResearchPartnerByBusinessId( id: number ): Observable<ResearchPartnerSimple> {
        return this.backendService.getData( `api/v1/fs/res/researchPartner/${id}` );
    }

    /**
     * save research partner in database
     *
     * @param researchPartner to save
     */
    saveResearchPartner( researchPartner: ResearchPartner ): Observable<number> {
        return this.backendService.postData( 'api/v1/fs/res/researchPartner', researchPartner );
    }

    /**
     * get research partner (external organizations) by text from database
     *
     * @param searchText contained in research partner
     */
    getValues( searchText: string ): Observable<ResearchPartnerSimple[]> {
        return this.backendService.getData( `api/v1/fs/res/researchPartner?q=${searchText}` );
    }

    /**
     * let the backend verify the rights if the auth can see research partner profiles
     * (need to be in BE because we cant check rightsparameter in FE)
     *
     * @param id of research partner
     */
    checkForViewResearchPartnerProfileRights( id: number ): Observable<boolean> {
        return this.backendService.postData(
            `api/v1/fs/res/hasRightsOnObject/ResearchPartner/${id}`,
            ['RIGHT_CS_PSV_ORGUNIT_VIEW_EXTERNAL_ORGUNIT'] );
    }
}
